(() => {
  const configNode = document.getElementById('bn-perks-config');
  if (!configNode) return;
  const config = JSON.parse(configNode.textContent);
  const t = config.text;
  const bag = document.querySelector('[data-bn-bag]');
  const root = config.root;
  let currentCart, previousFocus, requestVersion = 0;
  const money = (value, currency) => new Intl.NumberFormat('es-MX', {style:'currency', currency:currency || config.currency}).format(value / 100);
  function node(tag, text, className) {
    const element = document.createElement(tag);
    if (text !== undefined) element.textContent = text;
    if (className) element.className = className;
    return element;
  }
  function update(cart) {
    currentCart = cart;
    const count = cart.items.reduce((sum, item) => sum + (item.requires_shipping && !item.gift_card ? item.quantity : 0), 0);
    document.querySelectorAll('[data-bn-reward]').forEach(card => {
      card.dataset.count = String(Math.min(count, 2));
      card.querySelector('[data-reward-title]').textContent = count >= 2 ? t.ready : count === 1 ? t.one : t.start;
      card.querySelector('progress').value = Math.min(count, 2);
      card.querySelector('[data-reward-count]').textContent = t.count.replace('__count__', count);
      card.querySelector('[data-reward-saving]').textContent = count >= 2 ? t.saving : t.potential;
    });
    document.querySelectorAll('[data-cart-hats]').forEach(section => {
      let visible = 0;
      section.querySelectorAll('[data-hat-product]').forEach(card => {
        card.hidden = cart.items.some(item => String(item.product_id) === card.dataset.hatProduct);
        if (!card.hidden) visible++;
      });
      section.hidden = count !== 1 || visible === 0;
    });
    document.querySelectorAll('.bn-cart-count').forEach(el => { el.textContent = cart.item_count; });
    document.querySelectorAll('.bn-header-cart').forEach(el => el.setAttribute('aria-label',t.cart_label.replace('__count__',cart.item_count)));
    const list = bag.querySelector('[data-bag-items]');
    list.replaceChildren();
    if (!cart.items.length) list.append(node('p', t.empty, 'rte'));
    cart.items.forEach(item => {
      const row = node('div', undefined, 'bn-bag__item');
      const link = node('a', item.product_title);
      link.href = item.url;
      const imageUrl = item.featured_image?.url || item.image;
      if (imageUrl) {
        const image = node('img'); image.src = imageUrl; image.alt = ''; image.width = 72; image.height = 84;
        row.append(image);
      } else row.append(node('span'));
      const info = node('div'); info.append(link);
      if (item.variant_title && item.variant_title !== 'Default Title') info.append(node('small',item.variant_title));
      info.append(node('strong',item.quantity + ' × ' + money(item.final_price, cart.currency)));
      const remove = node('button',t.remove,'bn-bag__remove');remove.type = 'button';
      remove.addEventListener('click',async () => {
        remove.disabled = true;
        try {
          const response = await fetch(root+'cart/change.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({id:item.key,quantity:0})});
          if (!response.ok) throw new Error();
          requestVersion++;
          update(await response.json());
          bag.querySelector('[data-bag-close]').focus();
          document.dispatchEvent(new CustomEvent('bn:cart-changed'));
        } catch (_) { bag.querySelector('[data-bag-status]').textContent=t.error;remove.disabled=false; }
      });
      info.append(remove); row.append(info); list.append(row);
    });
    bag.querySelector('[data-bag-subtotal]').textContent=money(cart.total_price, cart.currency);
    bag.querySelector('[data-bag-checkout]').hidden = cart.item_count === 0;
  }
  async function refresh() {
    const version = ++requestVersion;
    const response = await fetch(root+'cart.js',{cache:'no-store',headers:{Accept:'application/json'}});
    if (!response.ok) throw new Error();
    const cart=await response.json();
    if (version === requestVersion) update(cart);
    return cart;
  }
  function open() {
    if (bag.open) return;
    previousFocus = document.activeElement;
    document.querySelectorAll('dialog[open]').forEach(dialog => dialog.close());
    bag.showModal(); document.body.classList.add('bn-bag-open');
    bag.querySelector('[data-bag-close]').focus();
  }
  bag.querySelector('[data-bag-close]').addEventListener('click',()=>bag.close());
  bag.addEventListener('close',()=>{document.body.classList.remove('bn-bag-open');if(previousFocus?.isConnected) previousFocus.focus();});
  bag.addEventListener('click',event=>{
    const rect=bag.getBoundingClientRect();
    if(event.target===bag && (event.clientX<rect.left || event.clientX>rect.right || event.clientY<rect.top || event.clientY>rect.bottom)) bag.close();
  });
  document.addEventListener('click',async event=>{
    const link=event.target.closest('.bn-header-cart');
    if(!link || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey || event.button!==0 || !bag.showModal) return;
    event.preventDefault();
    try {await refresh();bag.querySelector('[data-bag-status]').textContent='';open();}catch(_){location.assign(link.href);}
  });
  document.addEventListener('bn:cart-added',async ()=>{
    try {await refresh();bag.querySelector('[data-bag-status]').textContent=t.added;open();}catch(_){location.assign(root+'cart');}
  });
  window.addEventListener('pageshow',()=>refresh().catch(()=>{}));
  window.addEventListener('focus',()=>refresh().catch(()=>{}));
  document.addEventListener('bn:cart-rendered',()=>{if(currentCart)update(currentCart);});
  document.addEventListener('shopify:section:load',()=>{if(currentCart) update(currentCart);});
  refresh().catch(()=>{});
})();
